import { useState, type CSSProperties } from "react";

type BusinessLogoPreviewProps = {
  src?: string | null;
  name?: string | null;
  size?: number;
  alt?: string;
  className?: string;
};

function businessInitials(name?: string | null): string {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "B";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] ?? ""}${parts[1][0] ?? ""}`.toUpperCase();
}

export default function BusinessLogoPreview({
  src,
  name,
  size = 56,
  alt = "Business logo",
  className = "",
}: BusinessLogoPreviewProps) {
  const [failed, setFailed] = useState(false);
  const showImage = !!src?.trim() && !failed;

  const imgStyle: CSSProperties = {
    width: size,
    height: size,
    objectFit: "contain",
    display: "block",
  };

  if (!showImage) {
    return (
      <span
        className={`fw-bold text-primary d-inline-flex align-items-center justify-content-center flex-shrink-0 ${className}`}
        style={{ width: size, height: size, fontSize: Math.max(14, size * 0.36) }}
        aria-hidden
        title={name || alt}
      >
        {businessInitials(name)}
      </span>
    );
  }

  return (
    <img
      src={src!}
      alt={alt}
      className={`flex-shrink-0 ${className}`.trim()}
      style={imgStyle}
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
    />
  );
}
